import { Component, Input, OnInit } from '@angular/core';
import { Company } from 'app/services/interfaces/company';

@Component({
  selector: 'app-winery-card',
  templateUrl: './winery-card.component.html',
  styleUrl: './winery-card.component.scss'
})
export class WineryCardComponent implements OnInit {

  @Input() wineryCompany?: Company;

  ngOnInit(): void {
    console.log('wine card figlio avviato')
    console.log('Companies:', this.wineryCompany);
  }
}
